import React, { Component } from "react";
import PropTypes from "prop-types";
import { pdfjs, Document, Page } from "react-pdf";
import { withTranslation } from "react-i18next";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

class PreviewTermsConditions extends Component {
  state = {
    numPages: 0,
    width: 300,
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    const parentDiv = document.querySelector("#pdfDocument");
    this.setState({ numPages: numPages, width: parentDiv.clientWidth });
  };

  render() {
    return (
      <div>
        <div style={this.props.cardStyle} className={this.props.className}>
          <div id="pdfDocument" data-testid="pdfDocument">
            <Document
              file={this.props.file}
              onLoadSuccess={this.onDocumentLoadSuccess}
              noData={
                <h4 id="docNotFound">
                  {this.props.t("AcceptTermsConditions.docNotFound")}
                </h4>
              }
            >
              {Array.from(new Array(this.state.numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  width={this.state.width}
                  pageNumber={index + 1}
                  className="pdfPage"
                  renderMode="svg"
                />
              ))}
            </Document>
          </div>
        </div>
      </div>
    );
  }
}

PreviewTermsConditions.propTypes = {
  cardStyle: PropTypes.object,
  className: PropTypes.string,
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  t: PropTypes.func.isRequired,
};

export default withTranslation("emp")(PreviewTermsConditions);
